import {
  createSlice,
  createEntityAdapter,
  createSelector,
} from "@reduxjs/toolkit";
import {
  fetchAssigneesByEstateThunk,
  type Assignee,
} from "./assigneeListOperations";
import type { RootState } from "../../../../store/store";

const assigneeListAdapter = createEntityAdapter<Assignee>();

// @ts-ignore - Redux Toolkit 1.9.7 type issue
const assigneeListSlice = createSlice({
  name: "assigneeList",
  initialState: assigneeListAdapter.getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAssigneesByEstateThunk.fulfilled, (state, action) => {
      assigneeListAdapter.setAll(state, action.payload);
    });
  },
});

const selectors = assigneeListAdapter.getSelectors(
  (state: RootState) => (state.tickets.ticketDetail as any).assignees,
);

const selectIds = (_state: RootState, itemIds: number[]) => itemIds;

const selectByIds = createSelector(
  [selectors.selectAll, selectIds],
  (allAssignees, itemIds: number[] = []) => {
    const assignees = allAssignees.filter((assignee) =>
      itemIds.includes(assignee.id),
    );
    return assignees;
  },
);

export const assigneeListSelectors = { ...selectors, selectByIds };

export const reducer = assigneeListSlice.reducer;
